import { r as registerInstance, c as createEvent, h } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import './index-e29b327a.js';
import { s as send, q as paginationClickEvent } from './analytics-b6a65ffa.js';
import './_commonjsHelpers-11ca3be1.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './number-57a50dcb.js';
import './helpers-e12aa36b.js';

const pesPaginationCss = ".pes-pagination{display:flex}.pes-pagination__items{display:flex;font-size:14px;font-weight:400;margin:auto;padding-top:27px}.pes-pagination__item{box-sizing:border-box;display:inline-block;height:30px;color:#42b4e6;line-height:30px;min-width:30px;outline:0;padding:0 10px;text-align:center;-webkit-user-select:none;user-select:none}.pes-pagination__item:hover{cursor:pointer;background-color:rgba(98, 100, 105, 0.1)}.pes-pagination__item--active,.pes-pagination__item--active:hover{background:#626469;color:#ffffff;cursor:default;padding:0 10px}.pes-pagination__item--ellipsis:hover{background:none;cursor:default}.pes-pagination__item--arrow{background-repeat:no-repeat}.pes-pagination__item--arrow:hover{background-color:transparent;text-decoration:underline}.pes-pagination__item--next{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 6 10' width='6px' height='10px' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(-44 -3929)' fill='%2342B4E6' stroke='%2300B6EB' stroke-width='.1'%3E%3Cg transform='translate(15 3731)'%3E%3Cpath transform='translate(32 203) rotate(-90) translate(-32 -203)' d='m32.337 204.92c-0.032027 0.018721-0.065388 0.022733-0.098749 0.036105-0.03603 0.014709-0.070725 0.030756-0.10809 0.038779-0.044037 0.009361-0.085404 0.009361-0.13078 0.009361-0.044037 0-0.086739 0-0.12944-0.009361-0.038699-0.008023-0.07206-0.02407-0.10809-0.038779-0.033361-0.013372-0.068056-0.017384-0.098749-0.036105l-3.3294-2.5715c-0.31893-0.19925-0.42836-0.63919-0.2442-0.9842 0.18415-0.34367 0.59249-0.46268 0.91142-0.26343l2.9985 2.3161 2.9998-2.3161c0.31893-0.19925 0.72727-0.080233 0.91142 0.26343 0.18415 0.345 0.074729 0.78495-0.2442 0.9842l-3.3294 2.5715z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}:host(:not([dir=\"rtl\"])) .pes-pagination__item--next{background-position:center right;margin-left:10px}:host([dir=\"rtl\"]) .pes-pagination__item--next{background-position:center left;margin-right:10px}.pes-pagination__item--previous{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 6 10' width='6px' height='10px' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(-44 -3929)' fill='%2342B4E6' stroke='%2300B6EB' stroke-width='.1'%3E%3Cg transform='translate(15 3731)'%3E%3Cpath transform='translate(32 203) rotate(90) translate(-32 -203)' d='m32.337 204.92c-0.032027 0.018721-0.065388 0.022733-0.098749 0.036105-0.03603 0.014709-0.070725 0.030756-0.10809 0.038779-0.044037 0.009361-0.085404 0.009361-0.13078 0.009361-0.044037 0-0.086739 0-0.12944-0.009361-0.038699-0.008023-0.07206-0.02407-0.10809-0.038779-0.033361-0.013372-0.068056-0.017384-0.098749-0.036105l-3.3294-2.5715c-0.31893-0.19925-0.42836-0.63919-0.2442-0.9842 0.18415-0.34367 0.59249-0.46268 0.91142-0.26343l2.9985 2.3161 2.9998-2.3161c0.31893-0.19925 0.72727-0.080233 0.91142 0.26343 0.18415 0.345 0.074729 0.78495-0.2442 0.9842l-3.3294 2.5715z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}:host(:not([dir=\"rtl\"])) .pes-pagination__item--previous{background-position:center left;margin-right:10px}:host([dir=\"rtl\"]) .pes-pagination__item--previous{background-position:center right;margin-left:10px}";

const PesPagination = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pageSelected = createEvent(this, "pageSelected", 7);
    this.onClick = (pageNumber) => {
      send(paginationClickEvent, { articleTitle: pageNumber });
      this.pageSelected.emit(pageNumber);
    };
    this.elementsPerPage = undefined;
    this.total = undefined;
    this.selectedPage = undefined;
    this.previousLabel = 'Previous';
    this.nextLabel = 'Next';
  }
  static generatePages(size, startAt = 1) {
    let length = size;
    let currentPage = startAt;
    const pages = [];
    while (length--) {
      pages.push(currentPage++);
    }
    return pages;
  }
  get count() {
    return Math.ceil(this.total / this.elementsPerPage);
  }
  get isFirstPage() {
    return this.selectedPage === 1;
  }
  get isLastPage() {
    return this.selectedPage === this.count;
  }
  get pages() {
    const { count } = this;
    if (count <= PesPagination.LIMIT * 2) {
      return PesPagination.generatePages(count);
    }
    if (this.selectedPage <= PesPagination.LIMIT) {
      return this.generateTwoGroups(PesPagination.SMALL_SHIFT, PesPagination.BIG_SHIFT, count);
    }
    if (this.selectedPage > count - PesPagination.LIMIT) {
      return this.generateTwoGroups(PesPagination.BIG_SHIFT, PesPagination.SMALL_SHIFT, count);
    }
    return [
      ...PesPagination.generatePages(PesPagination.SMALL_SHIFT),
      PesPagination.DIVIDER,
      this.selectedPage - 1,
      this.selectedPage,
      this.selectedPage + 1,
      PesPagination.DIVIDER,
      ...PesPagination.generatePages(PesPagination.SMALL_SHIFT, count + 1 - PesPagination.SMALL_SHIFT),
    ];
  }
  generateTwoGroups(firstShift, secondShift, count) {
    const rightPosition = count - firstShift + 1;
    return [
      ...PesPagination.generatePages(secondShift),
      PesPagination.DIVIDER,
      ...PesPagination.generatePages(firstShift, rightPosition),
    ];
  }
  renderArrow(isNext) {
    const page = isNext ? this.selectedPage + 1 : this.selectedPage - 1;
    const label = isNext ? this.nextLabel : this.previousLabel;
    const classNames = classnames('pes-pagination__item', 'pes-pagination__item--arrow', {
      'pes-pagination__item--next': isNext,
      'pes-pagination__item--previous': !isNext,
    });
    return (h("span", { class: classNames, onClick: () => {
        this.onClick(page);
      } }, label));
  }
  render() {
    if (!this.elementsPerPage || this.total <= this.elementsPerPage) {
      return;
    }
    return (h("div", { class: "pes-pagination" }, h("div", { class: "pes-pagination__items" }, !this.isFirstPage && this.renderArrow(false), this.pages.map((page) => (page === PesPagination.DIVIDER ? (h("span", { class: "pes-pagination__item pes-pagination__item--ellipsis" }, "...")) : (h("span", { class: classnames('pes-pagination__item', {
        'pes-pagination__item--active': this.selectedPage === page,
      }), onClick: () => {
        this.onClick(page);
      } }, page)))), !this.isLastPage && this.renderArrow(true))));
  }
};
PesPagination.DIVIDER = 0;
PesPagination.LIMIT = 5;
PesPagination.SMALL_SHIFT = 4;
PesPagination.BIG_SHIFT = 6;
PesPagination.style = pesPaginationCss;

export { PesPagination as pes_pagination };
